import { render, staticRenderFns } from "./ModalAddPress.vue?vue&type=template&id=68dc71de&scoped=true"
import script from "./ModalAddPress.vue?vue&type=script&lang=js"
export * from "./ModalAddPress.vue?vue&type=script&lang=js"
import style0 from "./ModalAddPress.vue?vue&type=style&index=0&id=68dc71de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc71de",
  null
  
)

export default component.exports